import React, { useState } from 'react';
import { useAuth } from '../../AuthProvider';
import { useSubscription } from '../../../context/SubscriptionContext';
import { PERSONAL_WORKSPACE_ID } from '../../../utils/api';
import { CAN, can, normalizeWorkspaceRole } from '../../../utils/workspaceAccess';
import {
  planDetailForWorkspace,
  planLabelForWorkspace,
  planNoteForWorkspace,
  workspaceDisplayName,
  workspaceNeedsPlanPick,
} from '../../../utils/planLabel';

export function SettingsPlanSection() {
  const { workspaceId, workspaces } = useAuth();
  const sub = useSubscription();
  const [selectedPlan, setSelectedPlan] = useState('solo');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const currentRoom =
    (workspaces || []).find((w) => w.id === (workspaceId || PERSONAL_WORKSPACE_ID)) ||
    (workspaces || []).find((w) => w.id === PERSONAL_WORKSPACE_ID);
  const roomName = workspaceDisplayName(currentRoom);
  const isOwner = normalizeWorkspaceRole(currentRoom?.role) === 'owner';
  const mayManage = can(currentRoom?.role, CAN.manageBilling);
  const label = planLabelForWorkspace(currentRoom, sub);
  const detail = planDetailForWorkspace(currentRoom, sub);
  const note = planNoteForWorkspace(currentRoom, sub, { isOwner });
  const showPick = workspaceNeedsPlanPick(currentRoom, sub, { isOwner });
  const showManage = mayManage && !sub.complimentary && !showPick && sub.hasAccess;

  const handleCheckout = async () => {
    setBusy(true);
    setError('');
    try {
      const result = await sub.startCheckout(selectedPlan, workspaceId);
      if (result?.switched) setBusy(false);
    } catch {
      setError('Could not start checkout. Try again.');
      setBusy(false);
    }
  };

  return (
    <section className="settings-modal__section">
      <div className="settings-plan">
        <div className="settings-plan__card">
          <div className="settings-plan__kicker">Plan for {roomName}</div>
          <div className="settings-plan__name">
            {sub.loading ? '…' : label}
          </div>
          <p className="settings-plan__detail">
            {sub.loading ? 'Checking…' : detail}
          </p>
          {note && !sub.loading && (
            <p className="settings-plan__note">{note}</p>
          )}
        </div>

        {showPick && (
          <div className="settings-plan__picks">
            <button
              type="button"
              className={`settings-plan__pick ${selectedPlan === 'solo' ? 'settings-plan__pick--selected' : ''}`}
              onClick={() => setSelectedPlan('solo')}
            >
              <span className="settings-plan__pick-name">Solo</span>
              <span className="settings-plan__pick-meta">$30 / month · just you</span>
            </button>
            <button
              type="button"
              className={`settings-plan__pick ${selectedPlan === 'team' ? 'settings-plan__pick--selected' : ''}`}
              onClick={() => setSelectedPlan('team')}
            >
              <span className="settings-plan__pick-name">Team</span>
              <span className="settings-plan__pick-meta">$40 / seat · you plus people you invite</span>
            </button>
            <button
              type="button"
              className="settings-modal__action-btn"
              onClick={handleCheckout}
              disabled={busy || sub.loading}
            >
              {busy ? 'Starting checkout…' : 'Continue to checkout'}
            </button>
            <p className="settings-plan__note">
              Paying still starts a bill on your account. Soon each brain will have its own.
            </p>
            {error && <p className="settings-plan__error">{error}</p>}
          </div>
        )}

        {showManage && (
          <button
            type="button"
            className="settings-modal__action-btn"
            onClick={() => sub.openPortal()}
          >
            Manage in Stripe
          </button>
        )}
      </div>
    </section>
  );
}
